import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import { connect } from 'react-redux'
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import filterFactory from 'react-bootstrap-table2-filter'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { handleDeleteReport } from '../actions/emailReportsActions'
import Moment from 'react-moment'
import ReportActionCell from './ReportActionCell'

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'

import '../CompanyDetails/CompanyUsers/navoverrides.css'

const EmailReportTable = ({ companies }) => {
  const companyFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <div>{cell}</div>
  }

  const actionFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <ReportActionCell cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData} />
  }

  const recipientFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <div style={{ wordWrap: 'break-word', fontSize: '14px' }}>{cell}</div>
  }

  const dateFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <Moment format="DD/MM/YYYY">{cell}</Moment>
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Id',
      hidden: true,
      editable: false,
    },
    {
      dataField: 'companyName',
      text: 'Company Name',
      sort: true,
      editable: false,
      headerStyle: (column, colIndex) => {
        return { width: '300px' }
      },
      formatter: companyFormatter,
    },
    {
      dataField: 'emailRecipients',
      text: 'Recipients',
      sort: false,
      editable: false,
      formatter: recipientFormatter,
    },
    {
      dataField: 'created',
      text: 'Created',
      sort: false,
      editable: false,
      formatter: dateFormatter,
    },
    {
      dataField: 'dayOfMonth',
      text: 'Day of Month',
      sort: false,
      editable: false,
    },
    {
      dataField: 'reportActions',
      text: 'Actions',
      sort: false,
      editable: false,
        formatter: actionFormatter,
        headerStyle: (column, colIndex) => {
            return { width: '300px' }
        },
    },
  ]

  if (companies && companies.length > 0) {
    return (
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          totalSize: companies.length,
          sizePerPageList: [
            { text: '10', value: 10 },
            { text: '20', value: 20 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
            { text: 'All', value: companies.length },
          ],
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider bootstrap4 keyField="id" data={companies} columns={columns}>
            {(props) => {
              return (
                <div>
                  {/* <SearchBar {...props.searchProps} /> */}
                  <PaginationListStandalone {...paginationProps} />
                  <SizePerPageDropdownStandalone
                    btnContextual="btn-outline-primary"
                    className="dropDownStyle"
                    {...paginationProps}
                  />
                  <BootstrapTable
                    bordered={false}
                    {...props.baseProps}
                    pagination={paginationFactory()}
                    filter={filterFactory()}
                    filterPosition="top"
                    {...paginationTableProps}
                  />
                </div>
              )
            }}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    )
  } else {
    return <div style={{ paddingTop: '25px' }}>No Reports Found</div>
  }
}

const mapDispatchToProps = {
  handleDeleteReport,
}

export default connect(null, mapDispatchToProps)(EmailReportTable)
